<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <div class="content-section">
    <h2>Assurance Perte d'Exploitation</h2>
    <p>
      Si vous êtes à la recherche de ce type d'assurance <strong>Perte d'Exploitation</strong>, merci de prendre contact avec nous car il existe beaucoup trop de déclinaisons selon votre situation personnelle.
    </p>
    
    <div class="cta-container">
      <button class="btn-contact" (click)="navigateToContact()">
        Contactez-nous
      </button>
    </div>
  </div>

</app-page-layout>
